export class SearchConfig {
  rewrite: boolean;
  upload: boolean;
  browse: boolean;
  filesDirectory: string;
  indexedFilesDirectory: string;
  defaultDocument: string;
}
